export class ProjectNameListing {
    Id: number;
    Name: string;
}